export enum WinRatioType {
    TINY = "tiny",
    SMALL = "small",
    MEDIUM = "medium",
    LARGE = "large",
    BIG_WIN_01 = "bigWin01",
    BIG_WIN_02 = "bigWin02",
    BIG_WIN_03 = "bigWin03",
    BIG_WIN_04 = "bigWin04",
    BIG_WIN_05 = "bigWin05",
    BIG_WIN_06 = "bigWin06",
}

export enum Mental2SymbolStates {
    NORMAL,
    STOP,
    SPIN,
    WIN,
    NO_WIN,
    ONE_NINETY_EIGHT = "198",
    ONE_FORTY_EIGHT = "148",
    ONE_THIRTY_TWO = "132",
    ONE_HUNDRED_EIGHTEEN = "118",
    NINETY_NINE = "99",
    EIGHTY_FOUR = "84",
    SEVENTY_FOUR = "74",
    SIXTY_SIX = "66",
    SIXTY = "60",
    FIFTY_SIX = "56",
    FIFTY = "50",
    FORTY_FIVE = "45",
    FORTY = "40",
    THIRTY_TWO = "32",
    TWENTY_SIX = "26",
    NO_WIN_DARK = "no_win_dark",
    STANDARD_FS_ANTICIPATION = "standard_fs_anticipation",
    COOL_FS_ANTICIPATION = "cool_fs_anticipation",
    SUPER_FS_ANTICIPATION = "super_fs_anticipation",
    ENHANCER_REVEAL = "ENHANCER_REVEAL"
}

export enum FireFrameAnimName {
    HALF = "1x1_half_",
    SYMBOL = "1x1_",
    SYMBOL_X2_HALF = "1x2_half_",
    SYMBOL_X2 = "1x2_",
    SYMBOL_X3 = "1x3_",
}

export enum EnhancerEffects {
    OPEN = "open",
    FIRE_START = "open_start",
    FIRE_LOOP = "open_loop",
}

export enum GameFeatureMode {
    NORMAL = "NORMAL",
    RESPIN = "RESPIN",
    FREESPIN = "FREESPIN",
    FREESPIN_SUPER = "FREESPIN_SUPER",
    FREESPIN_COOL = "FREESPIN_BETTER",
    WIN_CAP = "WIN_CAP",
    PENTHOUSE = "PENTHOUSE",
    GAMBLE = "GAMBLE",
}

export enum DIRECTION{
    TOP,
    BOTTOM
}

export enum SYMBOL {
    S1 = "S1",
    S2 = "S2",
    M1 = "M1",
    M2 = "M2",
    M3 = "M3",
    M4 = "M4",
    M5 = "M5",
    L1 = "L1",
    L2 = "L2",
    L3 = "L3",
    L4 = "L4",
    L5 = "L5",
    LOCKED = "LOCKED",
    BLANK = "BLANK",
    WILD = "W",
    DEAD = "D",
    DEAD_ACTIVE = "D_A",
    X_SPLIT = "XSPLIT",
    X_WAYS = "XWAYS",
    X_NUDGE = "XNUDGE",
    X_HOLE = "XHOLE",
    GOD = "GOD",
    TS1 = "TS1",
    TS2 = "TS2",
    TS3 = "TS3",
    TS4 = "TS4",
    X_MENTAL = "XMENTAL",
}

export enum XHOLE_STATE {
    ANTICIPATION = "ANTICIPATION",
    NO_WIN = "NO_WIN",
    NONE = "NONE"
}
